import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import BasketHelper from '@helpers/BasketHelper'
import { basketRoute, branchesRoute, openCreditAccount } from '@constants/routes'
import { ReactComponent as Branch } from '@assets/svgs/icons/branch-finder.svg'
import { ReactComponent as Basket } from '@assets/svgs/icons/basket.svg'
import { ReactComponent as Account } from '@assets/svgs/icons/account.svg'
import './SecondaryNav.module.scss'

export default class SecondaryNav extends Component {
  state = {
    basketCount: BasketHelper.countItems()
  }

  componentDidMount () {
    document.addEventListener('updateBasket', this.refresh, false)
  }

  componentWillUnmount () {
    document.removeEventListener('updateBasket', () => {
      console.log('Listener closing down...')
    })
  }

  refresh = () => {
    const basketCount = BasketHelper.countItems()
    this.setState({ basketCount })
  }

  onClick = () => {
    const { click } = this.props
    click()
  }

  render () {
    const { basketCount } = this.state

    return (
      <Fragment>
        <Link to={branchesRoute} styleName='block-link' onClick={this.onClick}>
          <span styleName='icon-wrap'>
            <Branch styleName='icon' />
          </span>
          <span styleName='text'>
            Find a<br styleName='br' /> branch
          </span>
        </Link>
        <Link to={basketRoute} styleName='block-link' onClick={this.onClick}>
          <span styleName='icon-wrap'>
            {basketCount > 0 && <span styleName='counter'>{basketCount}</span>}
            <Basket styleName='icon' />
          </span>
          <span styleName='text'>
            Hire
            <br styleName='br' /> list
          </span>
        </Link>
        <Link to={openCreditAccount} styleName='block-link' onClick={this.onClick}>
          <span styleName='icon-wrap'>
            <Account styleName='icon' />
          </span>
          <span styleName='text'>
            Open a Credit
            <br styleName='br' /> Account
          </span>
        </Link>
      </Fragment>
    )
  }
}

SecondaryNav.propTypes = {
  click: PropTypes.func
}

SecondaryNav.defaultProps = {
  click: () => {}
}



// WEBPACK FOOTER //
// ./src/components/SecondaryNav/SecondaryNav.js